import React from 'react';
import moment from 'moment';
import { Modal, Button } from 'react-bootstrap';
import { ICON_CANCEL, ICON_SELECT } from '../../extras/icons';
//Función principal
const ProceedingResults = props => {
    //Tomo los props
    const { show, handleClose, audience, proceedings, handleSelect, setData } = props;
    //Inicializo la info
    //Manejo la selección
    const handleSelectProceeding = proceeding => {
        //Seteo el valor
        handleSelect(proceeding);
        //Seteo los datos
        setData({
            ...audience,
            numero: proceeding.numero,
            fecha_hecho: proceeding.fechaHecho ? moment(proceeding.fechaHecho).format('YYYY-MM-DD') : '',
            caratula: proceeding.caratula,
            id_origen: proceeding.legajoId
        });
        //Cierro el diálogo
        handleClose();
    }
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            //onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            scrollable
            size="xl"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Búsqueda de legajos: <strong>{ audience.numero }</strong>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-info">
                            A continuación se muestran los <strong>Legajos</strong> resultantes de la búsqueda. Seleccione el conveniente presionando el botón <ICON_SELECT />
                        </div>
                    </div>
                    <div className="col-12">
                        <table className="table table-striped table-hover table-sm">
                            <thead className="thead-light">
                                <tr>
                                    <th className="align-middle text-center">
                                        Legajo
                                    </th>
                                    <th className="align-middle text-center">
                                        Sel.
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    proceedings.map((proceeding, index) => (
                                        <tr key={`pr${proceeding.legajoId}-${index}`}>
                                            <td className="align-middle">
                                                <small>
                                                    ORIGEN: <strong>{ proceeding.origen }</strong>
                                                    <br/>
                                                    NÚMERO: <strong>{ proceeding.numero }</strong>
                                                    <br/>
                                                    CARÁTULA: <strong>{ proceeding.caratula }</strong>
                                                    <br/>
                                                    F. HECHO: <strong>{ proceeding.fechaHecho ? moment(proceeding.fechaHecho).format('DD/MM/YYYY') : '' }</strong>
                                                </small>
                                            </td>
                                            <td className="align-middle text-center">
                                                <Button size="sm" variant="success" onClick={() => handleSelectProceeding(proceeding)}>
                                                    <ICON_SELECT />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <ICON_CANCEL /> Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ProceedingResults;